module.exports = __webpack_public_path__ + "static/assets/1365bfadc3f1680f74a841dd9b736369.svg";